import React, { FC } from "react";
import type { PaymentOrchestrationSecureFundingProps } from "@/types";
import { ContentManager } from "../content-manager";
import { TextCols } from "../text-cols";

export const PaymentOrchestrationSecureFunding: FC<
  PaymentOrchestrationSecureFundingProps
> = ({ content, list }) => {
  return (
    <section className="paymentOrchestrationSecureFunding">
      <div className="paymentOrchestrationSecureFunding--inner">
        <div className="wrapper">
          <TextCols content={content} maxTitleWidth={766} />
        </div>
        <ContentManager
          content={list}
          className="paymentOrchestrationSecureFunding--list"
        />
      </div>
    </section>
  );
};
